import React from 'react';
import './PetAnimations.css';

export default function SnowGolemSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F5F5F0';
  const lightColor = color ? lighten(color) : '#FFFFFF';
  const darkColor = color ? darken(color) : '#D8D8D0';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Snow particles */}
      <circle cx="25" cy="20" r="1.5" fill={lightColor} opacity="0.6" />
      <circle cx="95" cy="35" r="1" fill={lightColor} opacity="0.5" />
      <circle cx="30" cy="55" r="1.2" fill={lightColor} opacity="0.4" />
      <circle cx="90" cy="15" r="1" fill={lightColor} opacity="0.6" />
      <circle cx="15" cy="40" r="1.3" fill={lightColor} opacity="0.5" />
      <circle cx="105" cy="55" r="1" fill={lightColor} opacity="0.4" />
      {/* Bottom snowball */}
      <circle cx="60" cy="85" r="24" fill={bodyColor} />
      <circle cx="60" cy="85" r="24" stroke={darkColor} strokeWidth="0.5" fill="none" />
      {/* Snow texture on bottom */}
      <circle cx="50" cy="92" r="2" fill={lightColor} opacity="0.5" />
      <circle cx="70" cy="88" r="1.5" fill={lightColor} opacity="0.4" />
      {/* Buttons */}
      <circle cx="60" cy="78" r="2" fill="#2C2419" />
      <circle cx="60" cy="86" r="2" fill="#2C2419" />
      <circle cx="60" cy="94" r="2" fill="#2C2419" />
      {/* Top snowball */}
      <circle cx="60" cy="50" r="18" fill={bodyColor} />
      <circle cx="60" cy="50" r="18" stroke={darkColor} strokeWidth="0.5" fill="none" />
      {/* Stick arms */}
      <line x1="42" y1="55" x2="18" y2="45" stroke="#6B4423" strokeWidth="3" strokeLinecap="round" />
      <line x1="18" y1="45" x2="12" y2="38" stroke="#6B4423" strokeWidth="2" strokeLinecap="round" />
      <line x1="18" y1="45" x2="14" y2="50" stroke="#6B4423" strokeWidth="2" strokeLinecap="round" />
      <line x1="78" y1="55" x2="102" y2="45" stroke="#6B4423" strokeWidth="3" strokeLinecap="round" />
      <line x1="102" y1="45" x2="108" y2="38" stroke="#6B4423" strokeWidth="2" strokeLinecap="round" />
      <line x1="102" y1="45" x2="106" y2="50" stroke="#6B4423" strokeWidth="2" strokeLinecap="round" />
      {/* Pumpkin head */}
      <rect x="40" y="20" width="40" height="30" rx="4" fill="#E8862E" />
      {/* Pumpkin ridges */}
      <path d="M50 20L50 50" stroke="#CC7525" strokeWidth="1" opacity="0.5" />
      <path d="M60 20L60 50" stroke="#CC7525" strokeWidth="1" opacity="0.5" />
      <path d="M70 20L70 50" stroke="#CC7525" strokeWidth="1" opacity="0.5" />
      {/* Pumpkin stem */}
      <rect x="57" y="16" width="6" height="6" rx="1" fill="#4A7A3A" />
      {/* Carved face - eyes */}
      <path d="M48 30L52 26L56 30Z" fill="#1A1A1A" />
      <path d="M64 30L68 26L72 30Z" fill="#1A1A1A" />
      {/* Carved face - mouth */}
      <path d="M48 38L52 42L56 38L60 42L64 38L68 42L72 38" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Glow inside carved face */}
      <path d="M48 30L52 26L56 30Z" fill="#FFB84D" opacity="0.3" />
      <path d="M64 30L68 26L72 30Z" fill="#FFB84D" opacity="0.3" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
